import { useMemo } from 'react';
import moment from 'moment';
import useGetQueueById from '@Hooks/queries/useGetQueueById';

const useGetQueueDetail = (queueId) => {
  const { data, isLoading, isError } = useGetQueueById(queueId);
  const queueInfo = data?.queue_info;

  const childData = useMemo(() => {
    if (!queueInfo) return null;
    const { child } = queueInfo;
    const parents = child?.parents;
    return {
      name:           child?.fullname ?? '-',
      birthdate:      child?.birthdate
                        ? moment(child.birthdate).format('DD-MM-YYYY')
                        : '-',
      gender:         child?.gender,
      fatherName:     parents?.father_name         ?? '-',
      motherName:     parents?.mother_name         ?? '-',
      address:        parents?.address             ?? '-',
      fatherPhone:    parents?.phone_number        ?? '-',
      motherPhone:    parents?.mother_phone_number ?? '-',
      isHealthWorker: parents?.is_health_worker,
      isFree:         parents?.is_free,
    };
  }, [queueInfo]);

  const visitData = useMemo(() => {
    if (!queueInfo) return null;
    const { shift } = queueInfo;
    return {
      shift: `${shift?.name} (${shift?.start_time} - ${shift?.end_time})`,
      date:  queueInfo.date
               ? moment(queueInfo.date).format('DD-MM-YYYY')
               : '-',
      note:  queueInfo.note,
    };
  }, [queueInfo]);

  const vaccinationData = useMemo(
    () => (queueInfo?.vaccinations?.length > 0 ? queueInfo.vaccinations : null),
    [queueInfo]
  );

  const currentStatus = useMemo(() => {
    if (!queueInfo) return null;
    return {
      value: queueInfo.queue_status?.id,
      label: queueInfo.queue_status?.name,
    };
  }, [queueInfo]);

  // Riwayat antrian terlewat: daftar antrian yang selesai sejak antrian ini
  // terlewat, dan asal tiket jika tiket ini dibuat ulang setelah batal otomatis.
  const passedHistory = useMemo(
    () => ({
      finishedSincePassed: queueInfo?.finished_since_passed ?? [],
      recreatedFrom: queueInfo?.recreated_from ?? null,
    }),
    [queueInfo]
  );

  return { isLoading, isError, childData, visitData, vaccinationData, currentStatus, passedHistory };
};

export default useGetQueueDetail;
